import { render, staticRenderFns } from "./ElPaslaugaStep.vue?vue&type=template&id=db52a9ee&"
import script from "./ElPaslaugaStep.vue?vue&type=script&lang=js&"
export * from "./ElPaslaugaStep.vue?vue&type=script&lang=js&"
import style0 from "./ElPaslaugaStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCol,VDivider,VRow,VStepper,VStepperHeader,VStepperStep})
